import { propFacts } from "../lib/property";

export default function PropertyFacts({ property }) {
  const f = propFacts(property);
  if (!f) {
    // Mocked data (data provider currently rejecting our key) is deliberately
    // hidden rather than shown as real facts — but silence reads as broken.
    // Say why instead of just showing nothing.
    if (property?.property?.[0]?._mocked) {
      return (
        <div className="s-facts-unavailable">
          Property details are temporarily unavailable from our data provider.
          You can still continue — pricing and other steps will use what you enter manually.
        </div>
      );
    }
    return null;
  }
  const rows = [
    ["Beds", f.beds ?? "—"],
    ["Baths", f.baths ?? "—"],
    ["Sqft", f.sqft ? f.sqft.toLocaleString() : "—"],
    ["Built", f.year_built ?? "—"],
    ["Lot sqft", f.lot_sqft ? f.lot_sqft.toLocaleString() : "—"],
    ["Assessed", f.assessed ? "$" + Number(f.assessed).toLocaleString() : "—"],
  ];
  return (
    <div className="s-facts">
      {rows.map(([l, v]) => (
        <div key={l} className="s-fact">
          <div className="s-fact-v">{v}</div>
          <div className="s-fact-l">{l}</div>
        </div>
      ))}
    </div>
  );
}
